module.exports = __webpack_public_path__ + "static/media/ic-open-in-new.b196768b.svg";